angular.module('ng-screen-query', []);

require('./queries/screen_device_query');
require('./commands/update_screen_device_command');
require('./models/screen_device_model');
require('./servants/screen_query_servant');
require('./servants/screen_device_subscription_servant');

export * from './servants/screen_query_servant';
export * from './servants/screen_device_subscription_servant';
export * from './models/screen_device_model';
export * from './queries/screen_device_query';

export default 'ng-screen-query';



// WEBPACK FOOTER //
// ./app/vendor/screen-query/src/main.ts